import { Component, Input, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'important-numbers',
    templateUrl: './important-numbers.component.html',
    styleUrls: ['./important-numbers.component.scss'],
    standalone: false
})

export class ImportantNumbersComponent implements OnInit {
  @Input() dynamicContent: Models.DynamicContent;
  @Input() create: any;

  constructor() {
  }

  ngOnInit() {
  }
}
